import { useNavigate } from "react-router-dom";
import HeroSection from "../Components/HeroSection";
import PricingSection from "../Components/PricingSection";
import Feature from "../Components/Feature";
import api from '../Services/api';
import toast from "react-hot-toast";

import partsImage from '../assets/parts.webp';
import vendorsImage from '../assets/vendors.webp';
import purchasersImage from '../assets/purchasers.webp';
import consigneesImage from '../assets/consignees.webp';
import cciImage from '../assets/cci_1.webp';
import cciImage2 from '../assets/cci_2.webp';
import cciImage3 from '../assets/cci_3.webp';
import cciImage4 from '../assets/cci_4.webp';
import logoImage from '../assets/logo.webp';
import cciHistoryImage from '../assets/cci_history.webp';


export default function Home() {
  const navigate = useNavigate();

  const FEATURES = [
    {
      images: [partsImage],
      title: "🔧 Parts Database",
      subtitle: "Your Central Hub for Customs-Ready Product Data",
      description: "Managing import/export documents starts with having the right product data — organized, accurate, and accessible. Our Parts Database feature simplifies global trade by helping you maintain a clean inventory of parts that’s ready for customs compliance at every step.",
      imageRight: false,
    },
    {
      images: [vendorsImage, purchasersImage, consigneesImage],
      title: "🌐 Trade Partner Databases",
      subtitle: "Your Single Source of Truth for All Key Trade Relationships",
      description: "Accurate and up-to-date trade partner records are essential for seamless cross-border compliance. Our Trade Partner Databases identify and consolidate your Vendors, Consignees, and Purchasers into one centralized system — ensuring every shipment is supported by verified, complete, and audit-ready partner information.",
      imageRight: false,
    },
    {
      images: [cciImage, cciImage2, cciImage3, cciImage4],
      title: "✅ Simplify Cross-Border Trade with Automated CCI & USMCA Certificate Creation",
      subtitle: "Your Data. Our Automation. Compliant Documentation in Seconds.",
      description: "Tired of manual paperwork, formatting errors, or compliance concerns when shipping goods across the Canada–U.S. border? Our web app takes the stress out of creating Canada Customs Invoices (CCI) and USMCA Certificates of Origin. Using your own product and customer data, our platform generates export-ready documents in just a few clicks — ensuring speed, accuracy, and full compliance with Canadian Customs and Free Trade Agreement requirements.",
      imageRight: false,
    },
    {
      images: [logoImage],
      title: "⭐ Professional Branding",
      subtitle: "Make a Strong First Impression with Your Custom-Branded Documents",
      description: "Your brand matters — even on customs paperwork. With our platform, Canada Customs Invoice (CCI) and USMCA Certificate you generate can be customized with your company logo and branding. Show your clients and partners that you’re professional, organized, and invested in delivering quality at every stage of the transaction — including your documentation.",
      imageRight: false,
    },
    {
      images: [cciHistoryImage],
      title: "📁 Canada Customs Invoice (CCI) History",
      subtitle: "Instantly Access Past Invoices — Anytime You Need Them",
      description: "Never dig through folders or resend requests again. With our CCI History feature, every customs invoice you generate is securely stored and easily searchable, so you can retrieve, review, and reuse past documentation in seconds. Whether you're responding to a customs audit, tracking a past shipment, or preparing repeat orders, your full invoice history is just a few clicks away.",
      imageRight: false,
    }
  ];

  const handleSubscribe = async (tier: string, interval: "month" | "year") => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/auth");
      return;
    }

    const userEmail = localStorage.getItem("userEmail");

    try {
      toast.loading("Redirecting to checkout...");

      const { data } = await api.post(
        "/stripe/checkout",
        {
          planId: tier,
          interval: interval,
          userId: token,
          email: userEmail,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.dismiss();
      window.location.href = data.url;
    } catch (error) {
      toast.dismiss();
      toast.error("Failed to start checkout. Please try again.");
    }
  };

  return (
    <div>
      <HeroSection />
      <div id="pricing">
        <PricingSection onSubscribe={handleSubscribe} />
      </div>
      <div id="features-showcase" className="py-12 bg-gray-50">
        <h2 className="text-3xl font-bold text-center mb-4">Features</h2>
        <div className="flex justify-center mb-8">
          <span className="inline-block w-24 h-1 rounded bg-secondary"></span>
        </div>
        <div className="max-w-[1600px] mx-auto flex flex-col gap-8 px-4">
          {FEATURES.map((feature, idx) => (
            <Feature
              key={feature.title}
              images={feature.images}
              title={feature.title}
              subtitle={feature.subtitle}
              description={feature.description}
              imageRight={feature.imageRight}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
